export default "__VITE_ASSET__CtrJ4ggW__"